import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["counter", "countdownText", "link"]
  static values = { timer: Number }

  connect() {
    if (!this.hasCounterTarget) {
      console.error("Counter target is missing")
      return
    }
    this.startTimer()
  }

  startTimer() {
    let seconds = this.timerValue
    this.countdown = setInterval(() => {
      seconds -= 1
      if (this.hasCounterTarget) {
        this.counterTarget.textContent = seconds
      }

      if (seconds <= 0) {
        clearInterval(this.countdown)
        this.countdownTextTarget.classList.add("hidden")
        this.linkTarget.classList.remove("hidden")
      }
    }, 1000)
  }

  disconnect() {
    if (this.countdown) {
      clearInterval(this.countdown)
    }
  }
}